// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2N0rN","colMaxWidth":"Table_colMaxWidth__38Bzw"};